module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vregi11-c644836ad49353eb2c2e27803b623264.jpg";